// HUMAN DATE
//
// Pass a JavaScript Date and the desired language.
// The default language is English.
//
// Returns an object:
// {
//   weekday: {
//     short: 'Wed',
//     long: 'Wednesday'
//   },
//   date: {
//     short: '5 Apr 2017',
//     long: '5 April 2017'
//   }
// }
// =============================================================================

import dateHelper from './dateHelper'

const locales = {
  en: {
    weekdays: {
      short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    },
    months: {
      short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      long: ['January', 'February', 'März', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    }
  },
  de: {
    weekdays: {
      short: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      long: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
    },
    months: {
      short: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
      long: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
    }
  }
}

export default function (date = new Date(), lang = 'en') {
  date = dateHelper.dateFromString(date)

  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()
  const weekday = date.getDay()

  const returnValue = {
    weekday: {
      short: locales[lang].weekdays.short[weekday],
      long: locales[lang].weekdays.long[weekday]
    },
    date: {
      short: '',
      long: ''
    }
  }

  switch (lang) {
    case 'de':
      returnValue.date.short = `${day}. ${locales[lang].months.short[month]} ${year}`
      returnValue.date.long = `${day}. ${locales[lang].months.long[month]} ${year}`
      return returnValue
    default:
      returnValue.date.short = `${day} ${locales[lang].months.short[month]} ${year}`
      returnValue.date.long = `${day} ${locales[lang].months.long[month]} ${year}`
      return returnValue
  }
}
